// Copia di Argomento.js adattata per la pagina Libreria (listing moduli)
const Libreria = ({idItem}) => {
    const [info, setInfo] = React.useState([]);
    const [dataLoaded, setDataLoaded] = React.useState(false);
    const [navbarData, setNavbarData] = React.useState([]);
    const [logged, setLogged] = React.useState(isLogged());
    const [statoAbbonamento, setStatoAbbonamento] = React.useState(null);
    const [moduli, setModuli] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [pageNumber, setPageNumber] = React.useState(1);
    const [morePosts, setMorePosts] = React.useState(false);
    const [idLastEpisode, setIdLastEpisode] = React.useState(0);
    const [activeTab, setActiveTab] = React.useState("opzione1");
    const [saved, setSaved] = React.useState([]);
    const [purchased, setPurchased] = React.useState([]);
    const [savedLoading, setSavedLoading] = React.useState(false);
    const [purchasedLoading, setPurchasedLoading] = React.useState(false);
    const [savedLoaded, setSavedLoaded] = React.useState(false);
    const [purchasedLoaded, setPurchasedLoaded] = React.useState(false);

    // All initial loading: fetch all modules from backend
    React.useEffect(() => {
        const init = async () => {
            try {
              const response = await callServerNoAuth('all-modules');
              if(response.success){
                  setModuli(Array.isArray(response.moduli) ? response.moduli : []);
                  setNavbarData(response.navLinks || []);
                  setDataLoaded(true);
              } else if (response.nextpage) {
                window.location.href = response.nextpage;
              }
            } catch (e) {
                setError('Errore nel caricamento dei moduli');
            } finally {
                setLoading(false);
            }
        };
        init();
    }, []);

    // Infinite scroll placeholder (non usato ma mantenuto per compatibilità)
    const observer = React.useRef();
    const lastItemElementRef = React.useCallback(node => {
        if (loading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && morePosts) {
                setPageNumber(prevPageNumber => prevPageNumber + 1);
            }
        }, { rootMargin: '200px' });

        if (node) observer.current.observe(node);
    }, [loading, morePosts]);

    if (!dataLoaded){
        return (
        <div className="c_w-100 c_h-100vh c_d-flex c_justify-content-center c_align-items-center">
            <span id="loader" className="loader c_grey c_d-flex" role="status" aria-live="polite"></span>
        </div>
    );}

    const fetchSaved = async () => {
        if (savedLoaded || savedLoading) return;
        setSavedLoading(true);
        try {
            const res = await callServer('library/preferiti');
            if (res && res.success) {
                setSaved(Array.isArray(res.items) ? res.items : []);
            }
            setSavedLoaded(true);
        } catch (e) {
        } finally {
            setSavedLoading(false);
        }
    };

    const fetchPurchased = async () => {
        if (purchasedLoaded || purchasedLoading) return;
        setPurchasedLoading(true);
        try {
            const res = await callServer('library/acquistati');
            if (res && res.success) {
                setPurchased(Array.isArray(res.items) ? res.items : []);
            }
            setPurchasedLoaded(true);
        } catch (e) {
        } finally {
            setPurchasedLoading(false);
        }
    };

    const handleTab = (tab) => {
        setActiveTab(tab);
        if (tab === "opzione1") {
            fetchSaved();
        } else if (tab === "opzione2") {
            fetchPurchased();
        }
    };

    const renderList = (list, isLoading) => {
        if (isLoading) {
            return (
                <div className="c_w-100 c_d-flex c_justify-content-center c_py-4">
                    <span id="loader" className="loader c_grey c_d-flex" role="status" aria-live="polite"></span>
                </div>
            );
        }
        if (!list || list.length === 0) {
            return <div className="c_font-2 c_clr-grey">Nessun elemento disponibile.</div>;
        }
        return (
            <div className="c_grid-preview" role="region" aria-live="polite">
                {list.map((m, i) => {
                    const thumbEpisode = (m.tipologia_contenuto === 3 && m.dati_episodio?.nome_copertina && m.slug_argomento && m.slug_modulo && m.slug_episodio)
                        ? `/public/src/episodi/${m.slug_argomento}/${m.slug_modulo}/${m.slug_episodio}/${m.dati_episodio.nome_copertina}`
                        : null;
                    const thumb = m.image
                        ?? thumbEpisode
                        ?? (m.lez_img ? `/public/src/img/bg-cover/jpg/temp/${m.lez_img}` : null);
                    const authorImage = m.aut_img;
                    const authorName = m.autore;
                    const authorPage = m.aut_page ?? "#";
                    const moduloLink = m.link ?? m.modulo ?? '#';
                    const lezioni = m.num_lez || m.numero_episodi;
                    const durata = m.dur_lez || m.durata;
                    const badge = m.tipologia_contenuto === 3
                        ? (m.numero_episodio ? `Episodio ${m.numero_episodio}` : null)
                        : (m.numero_modulo ? `Modulo ${m.numero_modulo}` : null);
                    return (
                        <article key={i} className="j_tweetid c_video-preview c_flex-col c_gap-15">
                            <div className="c_video-preview-image">
                                <a href={moduloLink} title={m.titolo}>
                                    {thumb && <img src={thumb} className="c_thumbnail" />}
                                </a>
                            </div>
                            <div className="c_d-flex c_w-100 c_gap-1 c_align-items-start c_px-5 c_600-px-0">
                                {authorImage &&
                                    <div className="c_author-preview-line">
                                        <img src={authorImage} title={authorName ?? ''} />
                                    </div>
                                }
                                <div className="c_video-preview-content">
                                    <div className="c_d-flex c_flex-col c_gap-2px">
                                        {badge && <h6 className="c_uppercase c_clr-primary-red c_font-800">{badge}</h6>}
                                        <div>
                                            <a href={moduloLink} className="c_no-style c_hover c_font-700 c_font-3" title={m.titolo}>{m.titolo}</a>
                                        </div>
                                    </div>
                                    <div>
                                        {authorName && <a href={authorPage} title={authorName} className="c_font-2 c_no-style c_hover c_font-bold">{authorName}</a>}
                                    </div>
                                    <div className="c_font-1">{lezioni} lezioni{durata && <>&ensp;&bull;&ensp;{durata}</>}</div>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
        );
    };

    return (
        <>
        <Navbar data={navbarData} logged={logged} />

        <main className="c_main c_relative">
            <section className="c_container c_flex-col c_justify-content-center c_pt-7 c_px-0 c_600-px-5 c_gap-4">
                <header className="c_d-flex c_flex-col c_gap-1 c_600-text-center c_px-5 c_600-px-0">
                    <h2 className="c_font-Libre_Baskerville c_italic c_font-regular c_font-6">Catalogo dei contenuti</h2>
                    <p className="c_font-3">Esplora le tematiche selezionate e trattate dai nostri esperti</p>
                </header>
            </section>
            <section className="c_container c_flex-col c_gap-4 c_px-0 c_600-px-5 c_pt-7">
                
                {/*<div className="c_font-1">{moduli.length} moduli disponibili</div>*/}

                <div className="c_grid-preview" role="region" aria-live="polite" id="moduli-container">
                    {moduli && moduli.map((m, i) => {
                        const thumb = m.image ?? (m.lez_img ? `/public/src/img/bg-cover/jpg/temp/${m.lez_img}` : null);
                        const authorImage = m.aut_img;
                        const authorName = m.autore;
                        const authorPage = m.aut_page ?? "#";
                        const moduloLink = m.link ?? m.modulo ?? '#';
                        const lezioni = m.num_lez || m.numero_episodi;
                        const durata = m.dur_lez || m.durata;
                        return (
                        <article key={i} className="j_tweetid c_video-preview c_flex-col c_gap-15" data-date={m.data_ultimo_caricamento}>
                                
                            <div className="c_video-preview-image">
                                <a href={moduloLink} title={m.titolo}>
                                    {thumb && <img src={thumb} className="c_thumbnail" />}
                                </a>
                            </div>

                            <div className="c_d-flex c_w-100 c_gap-1 c_align-items-start c_px-5 c_600-px-0">
                                {authorImage &&
                                    <div className="c_author-preview-line">
                                        <img src={authorImage} title={authorName ?? ''} />
                                    </div>
                                }
                                <div className="c_video-preview-content">
                                    <div className="c_d-flex c_flex-col c_gap-2px">
                                        {m.numero_modulo && <h6 className="c_uppercase c_clr-primary-red c_font-800">Modulo {m.numero_modulo}</h6>}
                                        <div>
                                            <a href={moduloLink} className="c_no-style c_hover c_font-700 c_font-3" title={m.titolo}>{m.titolo}</a>
                                        </div>
                                    </div>
                                    <div>
                                        {authorName && <a href={authorPage} title={authorName} className="c_font-2 c_no-style c_hover c_font-bold">{authorName}</a>}
                                    </div>
                                    <div className="c_font-1">{lezioni} lezioni{durata && <>&ensp;&bull;&ensp;{durata}</>}</div>

                                </div>
                            </div>

                        </article>
                    )})}
                </div>
                {logged && statoAbbonamento === 2 &&
                    <Advertising lastHR={false} />
                }
            </section>

            {/* Sezione Preferiti/Acquistati come in Salvati.js
            <section className="c_container c_flex-col c_gap-4 c_px-5 c_pt-7">
                <div className="c_d-flex c_flex-col c_gap-4">
                    <div className="c_d-flex c_align-items-center c_gap-2 c_clr-black">
                        <button
                        type="button"
                        onClick={() => handleTab("opzione1")}
                        className={"c_button-option " + (activeTab === "opzione1" && "c_activo")}
                        >
                        Preferiti
                        </button>

                        <button
                        type="button"
                        onClick={() => handleTab("opzione2")}
                        className={"c_button-option " + (activeTab === "opzione2" && "c_activo")}
                        >
                        Acquistati
                        </button>
                    </div>

                    {activeTab === "opzione1" && (
                        renderList(saved, savedLoading)
                    )}

                    {activeTab === "opzione2" && (
                        renderList(purchased, purchasedLoading)
                    )}
                </div>

            </section>
            */}

        </main>
        
        <Footer data={navbarData} logged={logged} />
        </>
    );
};

// Export default compat (se serve)
// export default Libreria;
